var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPayServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5684,
    y: 22.3994,
    width: 91.2627,
    height: 52.1501,
    fill: "#00B25C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7275,
    y: 22.3994,
    width: 29.3344,
    height: 52.1501,
    fill: "#84DEB3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9219,
    y: 28.918,
    width: 55.4095,
    height: 39.1126,
    fill: "#84DEB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0518 48.9072L19.4033 46.4072H18.5752V45.7432H19.2314L18.583 43.251H19.4189L20.0127 45.7432H21.0127L21.6377 43.251H22.4971L23.1221 45.7432H24.1221L24.7158 43.251H25.5518L24.9033 45.7432H25.5596V46.4072H24.7314L24.0752 48.9072H23.2158L22.5674 46.4072H21.5674L20.9189 48.9072H20.0518ZM20.1768 46.4072L20.4736 47.665H20.5283L20.8486 46.4072H20.1768ZM21.7471 45.7432H22.3955L22.0908 44.5791H22.0439L21.7471 45.7432ZM23.2939 46.4072L23.6064 47.6729H23.6533L23.958 46.4072H23.2939Z",
    fill: "#00C968"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.41992,
    y: 35.4014,
    width: 88.0033,
    height: 52.1501,
    fill: "#00C968"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.41992,
    y: 35.4492,
    width: 29.3344,
    height: 52.1501,
    fill: "#A4EECB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7354,
    y: 41.9688,
    width: 52.1501,
    height: 39.1126,
    fill: "#A4EECB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.29 80.0107L12.3447 72.5107H9.86035V70.5186H11.8291L9.88379 63.042H12.3916L14.1729 70.5186H17.1729L19.0479 63.042H21.626L23.501 70.5186H26.501L28.2822 63.042H30.79L28.8447 70.5186H30.8135V72.5107H28.3291L26.3604 80.0107H23.7822L21.8369 72.5107H18.8369L16.8916 80.0107H14.29ZM14.665 72.5107L15.5557 76.2842H15.7197L16.6807 72.5107H14.665ZM19.376 70.5186H21.3213L20.4072 67.0264H20.2666L19.376 70.5186ZM24.0166 72.5107L24.9541 76.3076H25.0947L26.0088 72.5107H24.0166Z",
    fill: "#00C968"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayServiceMain);
export default __webpack_public_path__ + "static/media/IcPayServiceMain.ba13ef244ffaeb8ae46a6ba2895d8f33.svg";
export { ForwardRef as ReactComponent };